import React from 'react';
import Modal from 'react-modal';
import './CreativeLibrary.css';

interface PhonePerfDashboardProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const PhonePerfDashboard: React.FC<PhonePerfDashboardProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="creative-modal"
      overlayClassName="creative-overlay"
    >
      <div className="modal-header-fc">
        <button onClick={onRequestClose} className="close-button">&times;</button>
      </div>
      
      <div style={{ width: '100%', height: '90vh', overflow: 'hidden' }}>
      <iframe title="iPhone Performance Dashboard" width="100%" height="100%" src="https://app.powerbi.com/reportEmbed?reportId=75a58b42-270a-467c-be0b-086b5d672791&autoAuth=true&ctid=41eb501a-f671-4ce0-a5bf-b64168c3705f" frameBorder="0" allowFullScreen={true}></iframe>
      </div>
    </Modal>
  );
};

export default PhonePerfDashboard;